"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectTagSummary = void 0;
var tslib_1 = require("tslib");
var base_1 = require("./base");
var IkeObjectTagSummary = /** @class */ (function (_super) {
    tslib_1.__extends(IkeObjectTagSummary, _super);
    function IkeObjectTagSummary() {
        var _this = _super.apply(this, tslib_1.__spreadArray([], tslib_1.__read(arguments), false)) || this;
        _this.className = 'TagSummary';
        _this.actionName = 'tag.summary';
        return _this;
    }
    return IkeObjectTagSummary;
}(base_1.IkeRestObject));
exports.IkeObjectTagSummary = IkeObjectTagSummary;
//# sourceMappingURL=tag.summary.object.js.map